import { render, staticRenderFns } from "./VersionSidebar.vue?vue&type=template&id=2bec35ef&scoped=true&"
import script from "./VersionSidebar.vue?vue&type=script&lang=ts&"
export * from "./VersionSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./VersionSidebar.vue?vue&type=style&index=0&id=2bec35ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bec35ef",
  null
  
)

export default component.exports